import React, { useEffect, useState } from 'react';
import { InputText } from 'primereact/inputtext';
import { Button } from 'primereact/button';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useDispatch } from 'react-redux';
import { endPoints } from '../../../Config';
import { handlePutRequest } from '../../../service/PutTemplate';
import { handleGetRequest } from '../../../service/GetTemplate';
import { InputTextarea } from 'primereact/inputtextarea';

const EditLevel1Question = ({ editable, viewable, onHide, rowRecord, onClose }) => {
    const [loadingBtn, setLoadingBtn] = useState(false);

    const dispatch = useDispatch();

    const validationSchema = Yup.object().shape({
        message: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('Question is required'),
        text: Yup.string()
            .matches(/^[^\s]+(\s[^\s]+)*$/, 'Leading and trailing space is not allowed')
            .required('Text is required')
    });

    const formik = useFormik({
        validationSchema,
        initialValues: {
            message: '',
            text: '',
            questionId: ''
        },
        onSubmit: async (data) => {
            setLoadingBtn(true);

            const editData = {
                message: data.message,
                text: data.text
            };
            const response = await dispatch(handlePutRequest(editData, endPoints.updateLevel1Question(data.questionId), true));
            if (response?.status === 200) {
                formik.resetForm();
                onHide();
            }
            setLoadingBtn(false);
        }
    });

    const getQuestionById = async () => {
        setLoadingBtn(true);
        const response = await handleGetRequest(endPoints.getLevel1QuestionById(rowRecord._id), true);
        if (response) {
            formik.setFieldValue('questionId', response?.data?._id);
            formik.setFieldValue('text', response?.data?.text);
            formik.setFieldValue('message', response?.data?.message);
        }

        setLoadingBtn(false);
    };

    useEffect(() => {
        if (editable || viewable) {
            getQuestionById();
        }
    }, [rowRecord]);

    return (
        <form onSubmit={formik.handleSubmit}>
            <div className="grid p-fluid">
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="message">
                            Text <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputText id="message" name="message" placeholder="Enter text" value={formik?.values?.message} maxLength={200} onChange={formik.handleChange} disabled={viewable} className="w-full" />
                        {formik.touched.message && formik.errors.message && <small className="p-error">{formik.errors.message}</small>}
                    </div>
                </div>
                <div className="col-12">
                    <div className="field mb-3">
                        <label htmlFor="text">
                            Question <span style={{ color: 'red' }}>*</span>
                        </label>
                        <InputTextarea id="text" name="text" placeholder="Enter Question" value={formik?.values?.text} maxLength={200} onChange={formik.handleChange} disabled={viewable} className="w-full" />
                        {formik.touched.text && formik.errors.text && <small className="p-error">{formik.errors.text}</small>}
                    </div>
                </div>
            </div>

            <div className="flex justify-content-center mt-4 gap-2">
                {!viewable && <Button label="Update" icon="pi pi-pencil" type="submit" disabled={loadingBtn} className="p-button-success p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} />}
                <Button label="Cancel" icon="pi pi-times" type="button" className="p-button-secondary p-button-sm" style={{ minWidth: 90, maxWidth: 120, width: 'auto' }} onClick={() => onClose()} />
            </div>
        </form>
    );
};

export default EditLevel1Question;
